export abstract class AppConstant {
  public static AdminTenant = 'admin'

  public static RoleGuest = 'Guest'
  public static RoleBasic = 'Basic'
  public static RoleSystemOwner = 'SystemOwner'

  public static DefaultDateFormat = 'dd/MM/yyyy';
  public static ServerDateFormat = 'YYYY/MM/DD';
}
